// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608210634/js/" + chunkId + "." + {"44":"1895ced9","225":"3de40edf","481":"ae06bc31","486":"806d07d2","770":"b2f0a3c6"}[chunkId] + ".0.11259685272278297.chunk.js";
};